export const getInitialState = (): any => ({
  viewUrlData: {},
  viewUrlStatus: 0
});
